import { createStore } from "vuex";

import authStore from "./modules/authStore";
import dataStore from "./modules/dataStore";

export default createStore({
  modules: {
    authStore,
    dataStore,
  },
  state: {},
  mutations: {},
  actions: {},
});
